export enum ProvisioningEnum {
  Reminder = 'reminder',
  Waitlist = 'waitlist',
  Feedback = 'feedback',
  Followup = 'followup',
  Referral = 'referral',
  OutboundReferral = 'outbound-referral',
  Chat = 'chat',
  Scheduler = 'scheduler',
  Recall = 'recall',
  Insurance = 'insurance',
  Broadcast = 'broadcast',
  Form = 'form',
  IntakeForm = 'intake-form',
  PrequalForm = 'prequal-form',
  Branding = 'branding',
  Upload = 'upload',
  Telehealth = 'telehealth',
  WaitingRoom = 'waiting-room',
}
